const uuid4Regex = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;
function isUUID4(value) {
  return !!value && uuid4Regex.test(value);
}
function isDefined(value) {
  return value != null;
}

export { isDefined, isUUID4 };
